import React from 'react';
import classes from './index.module.scss';
import DebtForm from 'components/generics/forms/DebtForm';
import LandaFinancingFormMobile from 'pages/lend/components/LandaFinancingForm/components/LandaFinancingFormMobile';

const LandaFinancingForm = () => {
  return (
    <>
      <LandaFinancingFormMobile className={classes.mobile} />
      <DebtForm className={classes.desktop} />
    </>
  );
};

export default LandaFinancingForm;
